<template>
  <GenericCard
    :locked="locked"
    :on-action="submitForm"
    :invalid="v$.peParty.$invalid"
    :dirty="v$.peParty.$anyDirty"
    title="Family Overview"
    :view-only="viewOnly"
  >
    <v-form
      :disabled="locked"
      @submit.prevent="submitForm"
    >
      <v-row>
        <v-col
          cols="12"
          md="4"
        >
          <v-row>
            <v-col
              cols="12"
              md="5"
            >
              <v-text-field
                v-model="peParty.num_marriages"
                autocomplete="off"
                label="# Marriages"
                outlined
                type="number"
                :error-messages="getErrorMessages(v$.peParty.num_marriages)"
                @input="v$.peParty.num_marriages.$touch()"
                @blur="v$.peParty.num_marriages.$touch()"
              />
            </v-col>
            <v-col cols="auto">
              <label for="currently_married">Currently Married?</label>
              <v-radio-group
                id="currently_married"
                v-model="peParty.currently_married"
                row
                :error-messages="getErrorMessages(v$.peParty.currently_married)"
                class="mt-0"
                @input="v$.peParty.currently_married.$touch()"
                @blur="v$.peParty.currently_married.$touch()"
              >
                <v-radio
                  label="No"
                  :value="false"
                />
                <v-radio
                  label="Yes"
                  :value="true"
                />
              </v-radio-group>
            </v-col>
          </v-row>
        </v-col>
        <v-col
          cols="12"
          md="3"
        >
          <v-text-field
            v-model="peParty.num_children"
            autocomplete="off"
            label="# Children"
            outlined
            type="number"
            :error-messages="getErrorMessages(v$.peParty.num_children)"
            @input="v$.peParty.num_children.$touch()"
            @blur="v$.peParty.num_children.$touch()"
          />
        </v-col>
        <v-col
          cols="12"
          md="4"
        >
          <v-autocomplete
            v-model="peParty.mother_status"
            :items="optionsMotherStatuses"
            label="Mother a USC or LPR?"
            outlined
            :error-messages="getErrorMessages(v$.peParty.mother_status)"
            @input="v$.peParty.mother_status.$touch()"
            @blur="v$.peParty.mother_status.$touch()"
          />
        </v-col>
        <v-col
          cols="12"
          md="4"
        >
          <v-autocomplete
            v-model="peParty.father_status"
            :items="optionsFatherStatuses"
            label="Father a USC or LPR?"
            outlined
            :error-messages="getErrorMessages(v$.peParty.father_status)"
            @input="v$.peParty.father_status.$touch()"
            @blur="v$.peParty.father_status.$touch()"
          />
        </v-col>
        <v-col
          cols="12"
          md="4"
        >
          <v-autocomplete
            v-model="peParty.spouse_status"
            :items="optionsSpouseStatuses"
            label="Spouse a USC or LPR?"
            outlined
            :error-messages="getErrorMessages(v$.peParty.spouse_status)"
            @input="v$.peParty.spouse_status.$touch()"
            @blur="v$.peParty.spouse_status.$touch()"
          />
        </v-col>
        <v-col
          cols="12"
          md="4"
        >
          <v-autocomplete
            v-model="peParty.child_status"
            :items="optionsChildStatuses"
            label="Child a USC or LPR?"
            outlined
            :error-messages="getErrorMessages(v$.peParty.child_status)"
            @input="v$.peParty.child_status.$touch()"
            @blur="v$.peParty.child_status.$touch()"
          />
        </v-col>
      </v-row>
      <v-row>
        <v-col cols="3">
          <v-text-field
            v-model="peParty.num_siblings"
            autocomplete="off"
            label="# Siblings"
            outlined
            type="number"
            :error-messages="getErrorMessages(v$.peParty.num_siblings)"
            @input="v$.peParty.num_siblings.$touch()"
            @blur="v$.peParty.num_siblings.$touch()"
          />
        </v-col>
        <v-col cols="auto">
          <label for="usc_siblings">Any Sibling USC?</label>
          <v-radio-group
            id="usc_siblings"
            v-model="peParty.usc_siblings"
            row
            :error-messages="getErrorMessages(v$.peParty.usc_siblings)"
            class="mt-0"
            @input="v$.peParty.usc_siblings.$touch()"
            @blur="v$.peParty.usc_siblings.$touch()"
          >
            <v-radio
              label="No"
              :value="false"
            />
            <v-radio
              label="Yes"
              :value="true"
            />
          </v-radio-group>
        </v-col>
        <v-col cols="auto">
          <label for="lpr_siblings">Any Sibling LPR?</label>
          <v-radio-group
            id="lpr_siblings"
            v-model="peParty.lpr_siblings"
            row
            :error-messages="getErrorMessages(v$.peParty.lpr_siblings)"
            class="mt-0"
            @input="v$.peParty.lpr_siblings.$touch()"
            @blur="v$.peParty.lpr_siblings.$touch()"
          >
            <v-radio
              label="No"
              :value="false"
            />
            <v-radio
              label="Yes"
              :value="true"
            />
          </v-radio-group>
        </v-col>
      </v-row>
    </v-form>
  </GenericCard>
</template>

<script>
import { mapActions, mapGetters, mapMutations } from 'vuex'
import { useVuelidate } from '@vuelidate/core'

import { alertHandler } from '@/alertHandler'

import { PARTY_NAMESPACE } from '@/store/party'
import { SHARED_NAMESPACE } from '@/store/shared'

import GenericCard from '@/components/Party/PartyEdit/SectionCards/GenericCard.vue'

export default {
  name: 'FamilyOverviewCard',
  components: { GenericCard },

  props: {
    viewOnly: {
      type: Boolean,
      default: false,
    },
  },

  setup () {
    return {
      v$: useVuelidate(),
      ...alertHandler(),
    }
  },

  data () {
    return { }
  },

  validations () {
    return {
      peParty: {
        child_status: {},
        currently_married: {},
        father_status: {},
        lpr_siblings: {},
        mother_status: {},
        num_children: {},
        num_marriages: {},
        num_siblings: {},
        spouse_status: {},
        usc_siblings: {},
      },
    }
  },

  computed: {
    locked: {
      get () {
        return this.peFamilyOverviewCardLock
      },

      set (value) {
        this.setPeFamilyOverviewCardLock(value)
      },
    },

    optionsChildStatuses () { return this.getCachedDropdown('parties/child_status') },
    optionsFatherStatuses () { return this.getCachedDropdown('parties/father_status') },
    optionsMotherStatuses () { return this.getCachedDropdown('parties/mother_status') },
    optionsSpouseStatuses () { return this.getCachedDropdown('parties/spouse_status') },

    ...mapGetters(PARTY_NAMESPACE, [
      'peFamilyOverviewCardLock',
      'peParty',
    ]),

    ...mapGetters(SHARED_NAMESPACE, [
      'getCachedDropdown',
    ]),
  },

  watch: {

  },

  created () {
    this.initPeFamilyOverviewCard()
    this.getDropdownOptions({ path: 'parties/child_status' })
    this.getDropdownOptions({ path: 'parties/father_status' })
    this.getDropdownOptions({ path: 'parties/mother_status' })
    this.getDropdownOptions({ path: 'parties/spouse_status' })
  },

  methods: {
    getErrorMessages (validator) { return validator?.$errors.map(e => e.$message) },

    async onCardUpdate () {
      return this.peFamilyOverviewCardUpdate({ id: this.peParty.id, section: this.peParty })
    },

    async onSectionUnlock () {
      return this.setPeFamilyOverviewCardLock(false)
    },

    async submitForm () {
      if (this.locked) return this.onSectionUnlock()
      else return this.onCardUpdate()
    },

    ...mapMutations(PARTY_NAMESPACE, [
      'setPeFamilyOverviewCardLock',
    ]),

    ...mapActions(PARTY_NAMESPACE, [
      'initPeFamilyOverviewCard',
      'peFamilyOverviewCardUpdate',
    ]),

    ...mapActions(SHARED_NAMESPACE, [
      'getDropdownOptions',
    ]),
  },
}
</script>
